<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="App Logo"
          class="shrink mr-2"
          contain
          src="@/assets/logo.png"
          transition="scale-transition"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn
        to="/users"
        text
      >
        <span class="mr-2">Users</span>
      </v-btn>

      <v-btn
        to="/tables"
        text
      >
        <span class="mr-2">Tables</span>
      </v-btn>
      <v-btn
        to="/broadcasts"
        text
      >
        <span class="mr-2">broadcasts</span>
      </v-btn><v-btn
        to="/broadcast/groups"
        text
      >
        <span class="mr-2">broadcasts group</span>
      </v-btn>
      <v-btn icon @click="logout"><v-icon>mdi-power</v-icon></v-btn>
    </v-app-bar>

    <v-main>
      <v-snackbar
          v-model="snackbar"
          :timeout="duration"
          top
          :color="color"
      >
        {{ message }}

        <template v-slot:action="{ attrs }">
          <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import firebase from 'firebase/compat/app'

export default {
  name: 'App',

  data: () => ({
    snackbar: false,
    loading: true,
    duration: 2000,
    timeUntilDismissed: 0,
  }),
  computed: {
    message() {
      return this.$store.getters.responseMsg
    },
    color() {
      return (this.$store.state.error) ? 'error' : 'success';
    }
  },
  methods: {
    async logout() {
      this.loading = true
      await firebase.auth().signOut()
      await this.$router.push('/login')
      this.loading = false
    },
  },
  watch: {
    message(v) {
      if (this.$route.path !== '/' && (v || '').indexOf('Login successful') >= 0) {
        return null
      }
      this.snackbar = true
      return v
    }
  },
  created() {
    const vm = this

    if (process.env.NODE_ENV === 'production') {
      this.$store.commit('setApiDomain', 'http://localhost:2222')
    }

    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        console.log('AUTH STATE CHANGED 1')
        // User is signed in.
        const {
          displayName,
          email,
          emailVerified,
          photoURL,
          uid,
          phoneNumber,
          providerData,
        } = user;


        vm.$store.commit('setUser', null)
        const fetchedUser = await vm.$store.dispatch('GET_USER', { email })

        if (fetchedUser && fetchedUser.status) {
          // User is signed in.
          user.getIdToken(true).then(async (idToken) => {
            if ([
                    'anthonystrange873@gmail.com',
                    'micatovin@gmail.com',
                    'elijahmboivin@gmail.com'
                ].indexOf(email.toLowerCase()) < 0
            ) {
              alert('User does not have access to this dashboard')
              return firebase.auth().signOut()
            }
            // console.log(idToken, 'idToken')
            await vm.$store.dispatch('LOGIN_USER', {
              email,
              status: fetchedUser.status,
              platform: 'ADMIN_DASH',
              uid,
              idToken
            })

            // firebase.analytics().logEvent('user-in', {
            //   user: user.email,
            //   value: new Date(Date.now()),
            // });
          })
        } else {
          alert('This user does not exist')
          // vm.$router.push('/login')
        }
      } else {
        // User is signed out.
        const noneAuthPaths = [
          '/login',
          '/privacy',
        ]
        // eslint-disable-next-line no-lonely-if
        if (noneAuthPaths.indexOf(window.location.pathname) < 0) {
          vm.$store.commit('setUser', null)
          vm.$router.push('/login').then()
        }
      }
    }, (error) => {
      // eslint-disable-next-line no-console
      console.log(error);
    })
  }
};
</script>
